import { Messages } from 'constants/messages';

export class CustomError extends Error {
  notificationText: string;

  constructor(message: string | undefined, notificationText: string) {
    super(message ?? notificationText);
    this.notificationText = notificationText;
  }
}

export class CommonCustomError extends CustomError {
  constructor(message?: string) {
    super(message, Messages.commonErrorMessage);
  }
}
